/**
 * Feature check client for proba-ui
 * Checks feature status via platform's external API endpoint
 */

const getPlatformUrl = (): string => {
  return process.env.REACT_APP_PLATFORM_URL || "http://localhost:3333"
}

const getJwtToken = (): string | null => {
  const jwt = localStorage.getItem("jwt")
  if (!jwt) return null
  // Remove "Bearer " prefix if present
  return jwt.replace(/^Bearer\s+/, "")
}

/**
 * Check if a feature is enabled
 * @param featureId - The feature ID to check (e.g., "intervention-manager")
 * @param projectId - Optional project ID to include in context
 * @returns Promise that resolves to true if feature is enabled, false otherwise
 */
export async function checkFeature(
  featureId: string,
  projectId?: string
): Promise<boolean> {
  try {
    const token = getJwtToken()
    if (!token) {
      console.warn("[Feature Check] No JWT token found in localStorage")
      return false
    }

    const platformUrl = getPlatformUrl()
    const url = new URL("/api/features/external/check", platformUrl)
    url.searchParams.set("feature", featureId)
    if (projectId) {
      url.searchParams.set("projectId", projectId)
    }

    const response = await fetch(url.toString(), {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}))
      console.error(
        `[Feature Check] API error for feature '${featureId}':`,
        response.status,
        errorData
      )
      return false
    }

    const data = await response.json()
    return Boolean(data.enabled)
  } catch (error) {
    console.error(`[Feature Check] Error checking feature '${featureId}':`, error)
    return false
  }
}

